'use client';

import React, { useEffect, useRef } from 'react';

interface CtaFinalProps {
  headline: string;
  body: string;
  cta: string;
  ctaHref?: string;
}

export default function CtaFinal({ headline, body, cta, ctaHref = '/request-meeting' }: CtaFinalProps) {
  const ref = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((e) => {
          if (e.isIntersecting) {
            e.target.classList.add('in');
            observer.unobserve(e.target);
          }
        });
      },
      { threshold: 0.12 }
    );
    const el = ref.current;
    if (el) observer.observe(el);
    return () => observer.disconnect();
  }, []);

  return (
    <section
      className="py-28 text-center"
      style={{ background: 'linear-gradient(150deg, var(--navy), var(--navy-deep))' }}
    >
      <div className="max-w-site mx-auto px-7">
        <div ref={ref} className="rev">
          <h2 className="heading-2 text-white">{headline}</h2>
          <p className="mt-5 mb-8 text-muted-cream text-[19px] leading-relaxed max-w-[56ch] mx-auto">
            {body}
          </p>
          <a
            href={ctaHref}
            className="inline-flex items-center gap-2.5 font-semibold text-sm px-7 py-4 rounded-[10px] bg-primary text-navy-deep border border-transparent transition-all duration-200 hover:bg-gold-bright hover:-translate-y-px hover:shadow-gold"
          >
            {cta}
          </a>
        </div>
      </div>
    </section>
  );
}